<template>
  <div class="wrapper">
    <section class="answer-one answer">
      <div class="container answer__container">
        <div class="answer__block--title six--block-answer">
            <span class="levels__love-bg">
                <picture>
                    <source srcset="~@/assets/img/level-love-6.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-love-6.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-love-6.png" class="image" width="54" height="166" alt="Love">
                </picture>
            </span>
          <h2 class="answer__title">Уровень 6</h2>
          <p class="answer__subtitle">Высокий:</p>
        </div>
        <div class="answer__content">
          <div class="process-bar__label">Потенциал любовной энергии</div>
          <div class="process-bar">
            <div class="process-bar__line result-6"></div>
            <div class="process-bar__value">98%</div>
          </div>
          <div class="process-bar-listing">
            <div class="process-bar-listing__title">Любовная энергия на данный момент:</div>
            <div class="process-bar-list__label">Любовь к себе</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-6_list_1"></div>
              <div class="process-bar-list__value">84%</div>
            </div>
            <div class="process-bar-list__label">Любовь к окружающим </div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-6_list_2"></div>
              <div class="process-bar-list__value">90%</div>
            </div>
            <div class="process-bar-list__label">Любовь к жизни</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-6_list_3"></div>
              <div class="process-bar-list__value">87%</div>
            </div>
          </div>
          <div class="text-icon">
            <img src="@/assets/img/svg/icon_1_text.svg" />
            <p>Вы — счастливица! Потому что <span>у вас огромный потенциал любовной энергии, который встречается очень редко:</span> не более 2% людей
              в мире обладают им. Вы
              в равной степени умеете как принимать, так
              и дарить любовь. </p>
          </div>
          <p class="answer__content--text">
            У вас высокий уровень энергии любви, так что <span>вы являетесь самодостаточной и уверенной
            в себе женщиной,</span> счастье
            и благополучие которой не зависит от наличия любовного союза
            и мужчины рядом. Вы придерживаетесь принципа, что
            в отношениях должно быть хорошо и комфортно, иначе они бессмысленны. Также <span>вы хорошо знаете себе цену,</span> поэтому
            не гонитесь за мужчинами,
            не навязываете им себя, не ревнуете и не завидуете другим. Такой здоровый подход помогает вам притягивать достойных и любящих партнеров в свою жизнь.
          </p>
          <div class="text-icon icon-top m28">
            <img src="@/assets/img/svg/icon_2_text.svg" />
            <p>Однако помните, что этот уровень любовной энергии <span>не является врожденным,</span> поэтому поддерживать его нужно на стабильной основе и продолжать работать над ним. </p>
          </div>
          <p class="answer__content--text no-margin">Иначе со временем вы можете потерять высокие показатели
            и спуститься на пару ступенек ниже.
            В таком случае придется бороться
            с куда <span>более серьезными</span> проблемами в личной жизни, так что лучше избежать последствий сразу.
          </p>
          <p class="answer__content--text m28">Вам необходимо поверить в себя и в собственные силы, не соглашаться на все, что вам предлагают, а самой делать выбор. Только так вы сможете поднять свой уровень энергии любви. </p>
          <div class="block-text">
            <div class="block-text__title">Высокий уровень любви даст вам:</div>
            <div class="block-text__text">— здоровую самооценку;
            </div>
            <div class="block-text__text">
              — умение любить себя такой, какая вы есть;
            </div>
            <div class="block-text__text">
              — способность быть любимой;
            </div>
            <div class="block-text__text">
              — счастливые отношения;
            </div>
            <div class="block-text__text">
              — внутреннее равновесие;
            </div>
            <div class="block-text__text">
              — избавление от одиночества.
            </div>
          </div>
          <div class="rs6">
            <span>Поддерживать высокий уровень</span> любовной энергии вам поможет <br><b>амулет «Энергия любви»</b>. Как <br>работает амулет и чем он <br>вам поможет — читайте тут
          </div>
          <div class="more">
            <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
          </div>
        </div>
      </div>
    </section>
    <FooterResult />
  </div>
</template>

<script>
import FooterResult from "@/components/FooterResult";
export default {
  name: "Result6",
  components: {FooterResult},
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  }
}
</script>